import React from "react";

export default function ProductCatalogColumnFilter({
  id,
  label,
  value,
  onChange,
  options,
}) {
  const className =
    "mt-2 w-full min-w-0 rounded border border-gray-300 bg-white px-1.5 py-1 text-xs font-normal focus:border-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200";

  if (options) {
    return (
      <select
        id={id}
        aria-label={`Filter by ${label}`}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={className}
      >
        <option value="">All</option>
        {options.map(({ value: optionValue, label: optionLabel }) => (
          <option key={optionValue} value={optionValue}>
            {optionLabel}
          </option>
        ))}
      </select>
    );
  }

  return (
    <input
      id={id}
      type="search"
      aria-label={`Filter by ${label}`}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Filter…"
      className={className}
    />
  );
}
